<div [class]="'h-full flex flex-column justify-content-center align-items-' + position" [ngClass]="className">
  <p-progressSpinner styleClass="custom-spinner" [style]="{ width: width, height: width }"></p-progressSpinner>
</div>
